const enrollmentFormTranslations = {
  en: {
    modalTitle: "Admission Process",
    modalSteps: [
      "Fill Enrollment Form",
      "Free Level Assessment",
      "Batch Allocation",
      "Admission Confirmation",
      "Start Learning",
    ],
    modalNote: "Admissions and payments are processed online from India only.",
    modalBtn: "I Understand",
    successTitle: "Enrollment Submitted Successfully!",
    successSubtitle: "Thank you for joining Gurmat Education Platform",
    successDesc:
      "You will receive an email with admission details and payment link. Further instructions will be provided upon successful completion. We wish you a wonderful learning journey ahead! 🚀",
    learnerName: "Learner Name",
    learnerNamePlaceholder: "Enter learner's full name",
    email: "Email",
    emailPlaceholder: "Enter email address",
    emailInvalid: "Please enter a valid email address.",
    emailExists: "This email is already registered.",
    emailCheckError: "Error checking email.",
    phone: "Code + Phone Number",
    phonePlaceholder: "Enter mobile number with country code",
    phoneInvalid: "Please enter a valid phone number with country code.",
    phoneExists: "This phone number is already registered.",
    phoneCheckError: "Error checking phone.",
    level: "Level",
    selectLevel: "Select Level",
    fatherName: "Father's Name",
    fatherNamePlaceholder: "Enter father's name",
    optionalClass: "Optional Class",
    selectOptionalClass: "None",
    country: "Country",
    selectCountry: "Select Country",
    address: "Address",
    addressPlaceholder: "Enter address with city and state",
    consentTitle: "PARENTS’ CONSENT & UNDERSTANDING",
    consentDesc: "Parent / Learner Consent",
    consentPoints: [
      "✔ Classes are conducted online",
      "✔ Learning is Gurmat-based and value-oriented",
      "✔ Progress depends on regular attendance & practice",
      "✔ Fees once paid are non-refundable",
      "✔ Recordings (if any) are for educational use only",
    ],
    consentLabel: "I agree to the above terms and consent to enrollment.",
    submitBtn: "Submit Enrollment",
    submitting: "Submitting...",
  },
  pa: {
    modalTitle: "ਦਾਖਲਾ ਪ੍ਰਕਿਰਿਆ",
    modalSteps: [
      "ਦਾਖਲਾ ਫਾਰਮ ਭਰੋ",
      "ਮੁਫ਼ਤ ਲੈਵਲ ਜਾਂਚ",
      "ਬੈਚ ਵੰਡ",
      "ਦਾਖਲਾ ਪੁਸ਼ਟੀ",
      "ਸਿੱਖਣਾ ਸ਼ੁਰੂ ਕਰੋ",
    ],
    modalNote: "ਦਾਖਲੇ ਅਤੇ ਭੁਗਤਾਨ ਸਿਰਫ਼ ਭਾਰਤ ਤੋਂ ਆਨਲਾਈਨ ਕੀਤੇ ਜਾਂਦੇ ਹਨ।",
    modalBtn: "ਮੈਨੂੰ ਸਮਝ ਆ ਗਿਆ",
    successTitle: "ਦਾਖਲਾ ਸਫਲਤਾਪੂਰਵਕ ਭੇਜਿਆ ਗਿਆ!",
    successSubtitle: "ਗੁਰਮਤਿ ਸਿੱਖਿਆ ਪਲੇਟਫਾਰਮ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਣ ਲਈ ਧੰਨਵਾਦ",
    successDesc:
      "ਤੁਹਾਨੂੰ ਮੁਫ਼ਤ ਜਾਂਚ ਦੇ ਨਤੀਜੇ ਈਮੇਲ ਰਾਹੀਂ ਮਿਲਣਗੇ। ਅੱਗੇ ਦੀ ਪ੍ਰਕਿਰਿਆ ਸਫਲਤਾਪੂਰਵਕ ਪੂਰੀ ਹੋਣ 'ਤੇ ਦੱਸੀ ਜਾਵੇਗੀ। ਅਸੀਂ ਤੁਹਾਨੂੰ ਸ਼ਾਨਦਾਰ ਸਿੱਖਣ ਯਾਤਰਾ ਦੀ ਸ਼ੁਭਕਾਮਨਾ ਦਿੰਦੇ ਹਾਂ! 🚀",
    learnerName: "ਵਿਦਿਆਰਥੀ ਦਾ ਨਾਮ",
    learnerNamePlaceholder: "ਵਿਦਿਆਰਥੀ ਦਾ ਪੂਰਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    email: "ਈਮੇਲ",
    emailPlaceholder: "ਈਮੇਲ ਦਰਜ ਕਰੋ",
    emailInvalid: "ਕਿਰਪਾ ਕਰਕੇ ਠੀਕ ਈਮੇਲ ਦਰਜ ਕਰੋ।",
    emailExists: "ਇਹ ਈਮੇਲ ਪਹਿਲਾਂ ਹੀ ਰਜਿਸਟਰ ਹੈ।",
    emailCheckError: "ਈਮੇਲ ਜਾਂਚਣ ਵਿੱਚ ਗਲਤੀ।",
    phone: "ਮੋਬਾਈਲ ਨੰਬਰ (ਦੇਸ਼ ਕੋਡ ਸਮੇਤ)",
    phonePlaceholder: "ਦੇਸ਼ ਕੋਡ ਸਮੇਤ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    phoneInvalid: "ਕਿਰਪਾ ਕਰਕੇ ਠੀਕ ਮੋਬਾਈਲ ਨੰਬਰ ਦਰਜ ਕਰੋ।",
    phoneExists: "ਇਹ ਮੋਬਾਈਲ ਨੰਬਰ ਪਹਿਲਾਂ ਹੀ ਰਜਿਸਟਰ ਹੈ।",
    phoneCheckError: "ਮੋਬਾਈਲ ਜਾਂਚਣ ਵਿੱਚ ਗਲਤੀ।",
    level: "ਲੈਵਲ",
    selectLevel: "ਲੈਵਲ ਚੁਣੋ",
    fatherName: "ਪਿਤਾ ਦਾ ਨਾਮ",
    fatherNamePlaceholder: "ਪਿਤਾ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
    optionalClass: "ਵਿਕਲਪਿਕ ਕਲਾਸ",
    selectOptionalClass: "ਕੋਈ ਨਹੀਂ",
    country: "ਦੇਸ਼",
    selectCountry: "ਦੇਸ਼ ਚੁਣੋ",
    address: "ਪਤਾ",
    addressPlaceholder: "ਸ਼ਹਿਰ ਅਤੇ ਰਾਜ ਸਮੇਤ ਪਤਾ ਦਰਜ ਕਰੋ",
    consentTitle: "ਮਾਤਾ-ਪਿਤਾ ਦੀ ਸਹਿਮਤੀ ਅਤੇ ਸਮਝ",
    consentDesc: "ਮਾਤਾ-ਪਿਤਾ / ਵਿਦਿਆਰਥੀ ਦੀ ਸਹਿਮਤੀ",
    consentPoints: [
      "✔ ਕਲਾਸਾਂ ਆਨਲਾਈਨ ਚਲਦੀਆਂ ਹਨ",
      "✔ ਸਿੱਖਿਆ ਗੁਰਮਤਿ-ਅਧਾਰਿਤ ਅਤੇ ਮੁੱਲਾਂ ਵਾਲੀ ਹੈ",
      "✔ ਤਰੱਕੀ ਨਿਯਮਿਤ ਹਾਜ਼ਰੀ ਅਤੇ ਅਭਿਆਸ 'ਤੇ ਨਿਰਭਰ ਕਰਦੀ ਹੈ",
      "✔ ਫੀਸ ਇਕ ਵਾਰ ਭਰੀ ਗਈ ਤਾਂ ਵਾਪਸ ਨਹੀਂ ਹੁੰਦੀ",
      "✔ ਰਿਕਾਰਡਿੰਗ (ਜੇ ਹੋਵੇ) ਸਿੱਖਿਆ ਲਈ ਹੀ ਵਰਤੀ ਜਾਂਦੀ ਹੈ",
    ],
    consentLabel:
      "ਮੈਂ ਉਪਰੋਕਤ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਹਾਂ ਅਤੇ ਦਾਖਲੇ ਲਈ ਸਹਿਮਤੀ ਦਿੰਦਾ/ਦਿੰਦੀ ਹਾਂ।",
    submitBtn: "ਦਾਖਲਾ ਭੇਜੋ",
    submitting: "ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
  },
};

export default enrollmentFormTranslations;
